// // import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
// // import axios from "axios";
// // import { Cart } from "../../types/cartTypes";
// // import { Coupon, CouponState } from "../../types/couponTypes";
// // import { api } from "../../Config/Api";

// // const API_URL = "/api/coupons";

// // // Async thunks
// // export const applyCoupon = createAsyncThunk<
// //   Cart,
// //   {
// //     apply: string;
// //     code: string;
// //     orderValue: number;
// //     jwt: string;
// //   },
// //   { rejectValue: string }
// // >(
// //   "coupon/applyCoupon",
// //   async ({ apply, code, orderValue, jwt }, { rejectWithValue }) => {
// //     try {
// //       const response = await api.post(`${API_URL}/apply`, null, {
// //         params: { apply, code, orderValue },
// //         headers: { Authorization: `Bearer ${jwt}` },
// //       });
// //       console.log("aplly coupon ", response.data);
// //       return response.data;
// //     } catch (error: any) {
// //       console.log("error", error);
// //       return rejectWithValue(error.response?.data.error || "Failed to apply coupon");
// //     }
// //   }
// // );

// // // Initial state
// // const initialState: CouponState = {
// //   coupons: [],
// //   cart: null,
// //   loading: false,
// //   error: null,
// //   couponCreated: false,
// //   couponApplied: false,

// // };

// // // Slice
// // const couponSlice = createSlice({
// //   name: "coupon",
// //   initialState,
// //   reducers: {},
// //   extraReducers: (builder) => {
// //     builder
// //       .addCase(applyCoupon.pending, (state) => {
// //         state.loading = true;
// //         state.error = null;
// //         state.couponApplied=false;
// //       })
// //       .addCase(applyCoupon.fulfilled, (state, action) => {
// //         state.loading = false;
// //         state.cart = action.payload;
        
// //         if(action.meta.arg.apply=="true"){
// //           state.couponApplied=true
// //         }
        
// //       })
// //       .addCase(
// //         applyCoupon.rejected,
// //         (state, action: PayloadAction<string | undefined>) => {
// //           state.loading = false;
// //           state.error = action.payload || "Failed to apply coupon";
// //           state.couponApplied=false;
// //         }
// //       );
// //   },
// // });

// // export default couponSlice.reducer;




// import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
// import { Cart } from "../../types/cartTypes";
// import { CouponState } from "../../types/couponTypes";
// import { api } from "../../Config/Api";

// const API_URL = "/api/coupons";

// export const applyCoupon = createAsyncThunk<
//   Cart,
//   {
//     apply: string;
//     code: string;
//     orderValue: number;
//     jwt: string;
//   },
//   { rejectValue: string }
// >(
//   "coupon/applyCoupon",
//   async ({ apply, code, orderValue, jwt }, { rejectWithValue }) => {
//     try {
//       const response = await api.post(`${API_URL}/apply`, null, {
//         params: { apply, code, orderValue },
//         headers: { Authorization: `Bearer ${jwt}` },
//       });

//       return response.data;
//     } catch (error: any) {
//       return rejectWithValue(
//         error.response?.data?.error ||
//           error.response?.data?.message ||
//           "Failed to apply coupon"
//       );
//     }
//   }
// );

// const initialState: CouponState = {
//   coupons: [],
//   cart: null,
//   loading: false,
//   error: null,
//   couponCreated: false,
//   couponApplied: false,
// };

// const couponSlice = createSlice({
//   name: "coupon",
//   initialState,
//   reducers: {
//     clearCouponState: (state) => {
//       state.error = null;
//       state.couponApplied = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(applyCoupon.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.couponApplied = false;
//       })
//       .addCase(applyCoupon.fulfilled, (state, action) => {
//         state.loading = false;
//         state.cart = action.payload;
//         state.error = null;

//         if (action.meta.arg.apply === "true") {
//           state.couponApplied = true;
//         } else {
//           state.couponApplied = false;
//         }
//       })
//       .addCase(
//         applyCoupon.rejected,
//         (state, action: PayloadAction<string | undefined>) => {
//           state.loading = false;
//           state.error = action.payload || "Failed to apply coupon";
//           state.couponApplied = false;
//         }
//       );
//   },
// });

// export const { clearCouponState } = couponSlice.actions;

// export default couponSlice.reducer;



import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { Cart } from "../../types/cartTypes";
import { Coupon, CouponState } from "../../types/couponTypes";
import { api } from "../../Config/Api";

const API_URL = "/api/coupons";

export const applyCoupon = createAsyncThunk<
  Cart,
  {
    apply: string;
    code: string;
    orderValue: number;
    jwt: string;
  },
  { rejectValue: string }
>(
  "coupon/applyCoupon",
  async ({ apply, code, orderValue, jwt }, { rejectWithValue }) => {
    try {
      const response = await api.post(`${API_URL}/apply`, null, {
        params: { apply, code, orderValue },
        headers: { Authorization: `Bearer ${jwt}` },
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.error ||
          error.response?.data?.message ||
          "Failed to apply coupon"
      );
    }
  }
);

export const fetchAllCoupons = createAsyncThunk<
  Coupon[],
  string,
  { rejectValue: string }
>("coupon/fetchAllCoupons", async (jwt, { rejectWithValue }) => {
  try {
    const response = await api.get(`${API_URL}/customer/available`, {
      headers: { Authorization: `Bearer ${jwt}` },
    });

    return response.data;
  } catch (error: any) {
    return rejectWithValue(
      error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to fetch coupons"
    );
  }
});

const initialState: CouponState = {
  coupons: [],
  cart: null,
  loading: false,
  error: null,
  couponCreated: false,
  couponApplied: false,
};

const couponSlice = createSlice({
  name: "coupon",
  initialState,
  reducers: {
    clearCouponState: (state) => {
      state.error = null;
      state.couponApplied = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(applyCoupon.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.couponApplied = false;
      })
      .addCase(applyCoupon.fulfilled, (state, action) => {
        state.loading = false;
        state.cart = action.payload;
        state.error = null;
        state.couponApplied = action.meta.arg.apply === "true";
      })
      .addCase(
        applyCoupon.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.loading = false;
          state.error = action.payload || "Failed to apply coupon";
          state.couponApplied = false;
        }
      )
      .addCase(fetchAllCoupons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchAllCoupons.fulfilled,
        (state, action: PayloadAction<Coupon[]>) => {
          state.loading = false;
          state.coupons = action.payload;
        }
      )
      .addCase(
        fetchAllCoupons.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.loading = false;
          state.error = action.payload || "Failed to fetch coupons";
        }
      );
  },
});

export const { clearCouponState } = couponSlice.actions;

export default couponSlice.reducer;